import instance, { customConfig } from "../Utils/Interceptors/Interceptor";

const ParametrosCalculadoraService = async (values) => {
	try {
		return await instance.Backend.post("/Indicador/ParametrosCalculadora", values, customConfig);
	} catch (error) {
		console.log(error);
	}
};

export { ParametrosCalculadoraService };
